export const ALLOW_COOKIES = 'ALLOW_COOKIES';

export const allowCookieConsent = allowCookies => ({
  type: ALLOW_COOKIES,
  allowCookies,
});



// WEBPACK FOOTER //
// ./src/client/js/store/actions/cookies/cookieConsent.js